'use strict';

var React = require('react');

var SvgPriceLookupMinor = function SvgPriceLookupMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.189 14.25a4.001 4.001 0 0 1-5.648-2h-.791a.75.75 0 0 1 0-1.5h.5c0-.729.195-1.412.535-2h-1.035a.75.75 0 0 1 0-1.5h2.562a4 4 0 0 1 5.033 6.034l1.935 1.936a.75.75 0 1 1-1.06 1.06l-2.031-2.03Zm.561-3.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.75a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z"
  }));
};
SvgPriceLookupMinor.displayName = "PriceLookupMinor";

exports.SvgPriceLookupMinor = SvgPriceLookupMinor;
